// Sample NFT data for Kanpai Pandas collection
export const pandasNFTs = [
  {
    id: 2109,
    name: "Kanpai Panda #2109",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2109",
    price: 0.72
  },
  {
    id: 5830,
    name: "Kanpai Panda #5830",
    image: "https://prodftpserver.blob.core.windows.net/images/default/5830",
    price: 0.75
  },
  {
    id: 7086,
    name: "Kanpai Panda #7086",
    image: "https://prodftpserver.blob.core.windows.net/images/default/7086",
    price: 0.78
  },
  {
    id: 3872,
    name: "Kanpai Panda #3872",
    image: "https://prodftpserver.blob.core.windows.net/images/default/3872",
    price: 0.82
  },
    {
    id: 3299,
    name: "Kanpai Panda #3299",
    image: "https://prodftpserver.blob.core.windows.net/images/default/3299",
    price: 1.25
},
{
    id: 2580,
    name: "Kanpai Panda #2580",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2580",
    price: 1.85
},
{
    id: 7730,
    name: "Kanpai Panda #7730",
    image: "https://prodftpserver.blob.core.windows.net/images/default/7730",
    price: 2.15
},
{
    id: 2071,
    name: "Kanpai Panda #2071",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2071",
    price: 0.95
},
{
    id: 2694,
    name: "Kanpai Panda #2694",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2694",
    price: 1.45
},
{
    id: 4131,
    name: "Kanpai Panda #4131",
    image: "https://prodftpserver.blob.core.windows.net/images/default/4131",
    price: 2.35
},
{
    id: 3554,
    name: "Kanpai Panda #3554",
    image: "https://prodftpserver.blob.core.windows.net/images/default/3554",
    price: 1.65
},
{
    id: 7845,
    name: "Kanpai Panda #7845",
    image: "https://prodftpserver.blob.core.windows.net/images/default/7845",
    price: 0.82
},
{
    id: 2492,
    name: "Kanpai Panda #2492",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2492",
    price: 2.45
},
{
    id: 2127,
    name: "Kanpai Panda #2127",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2127",
    price: 1.75
},
{
    id: 2126,
    name: "Kanpai Panda #2126",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2126",
    price: 1.95
},
{
    id: 5913,
    name: "Kanpai Panda #5913",
    image: "https://prodftpserver.blob.core.windows.net/images/default/5913",
    price: 2.25
},
{
    id: 6001,
    name: "Kanpai Panda #6001",
    image: "https://prodftpserver.blob.core.windows.net/images/default/6001",
    price: 1.15
},
{
    id: 6002,
    name: "Kanpai Panda #6002",
    image: "https://prodftpserver.blob.core.windows.net/images/default/6002",
    price: 1.55
},
{
    id: 5739,
    name: "Kanpai Panda #5739",
    image: "https://prodftpserver.blob.core.windows.net/images/default/5739",
    price: 2.05
},
{
    id: 6850,
    name: "Kanpai Panda #6850",
    image: "https://prodftpserver.blob.core.windows.net/images/default/6850",
    price: 1.35
},
{
    id: 5601,
    name: "Kanpai Panda #5601",
    image: "https://prodftpserver.blob.core.windows.net/images/default/5601",
    price: 0.92
},
{
    id: 5600,
    name: "Kanpai Panda #5600",
    image: "https://prodftpserver.blob.core.windows.net/images/default/5600",
    price: 2.42
},
{
    id: 5984,
    name: "Kanpai Panda #5984",
    image: "https://prodftpserver.blob.core.windows.net/images/default/5984",
    price: 1.82
},
{
    id: 5985,
    name: "Kanpai Panda #5985",
    image: "https://prodftpserver.blob.core.windows.net/images/default/5985",
    price: 2.32
},
{
    id: 5983,
    name: "Kanpai Panda #5983",
    image: "https://prodftpserver.blob.core.windows.net/images/default/5983",
    price: 1.22
},
{
    id: 5970,
    name: "Kanpai Panda #5970",
    image: "https://prodftpserver.blob.core.windows.net/images/default/5970",
    price: 1.62
},
{
    id: 5982,
    name: "Kanpai Panda #5982",
    image: "https://prodftpserver.blob.core.windows.net/images/default/5982",
    price: 2.12
},
{
    id: 5969,
    name: "Kanpai Panda #5969",
    image: "https://prodftpserver.blob.core.windows.net/images/default/5969",
    price: 0.88
},
{
    id: 7051,
    name: "Kanpai Panda #7051",
    image: "https://prodftpserver.blob.core.windows.net/images/default/7051",
    price: 2.48
},
{
    id: 6511,
    name: "Kanpai Panda #6511",
    image: "https://prodftpserver.blob.core.windows.net/images/default/6511",
    price: 1.72
},
{
    id: 3886,
    name: "Kanpai Panda #3886",
    image: "https://prodftpserver.blob.core.windows.net/images/default/3886",
    price: 1.92
},
{
    id: 2522,
    name: "Kanpai Panda #2522",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2522",
    price: 2.22
},
{
    id: 2523,
    name: "Kanpai Panda #2523",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2523",
    price: 1.12
},
{
    id: 2524,
    name: "Kanpai Panda #2524",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2524",
    price: 1.52
},
{
    id: 8105,
    name: "Kanpai Panda #8105",
    image: "https://prodftpserver.blob.core.windows.net/images/default/8105",
    price: 2.02
},
{
    id: 3427,
    name: "Kanpai Panda #3427",
    image: "https://prodftpserver.blob.core.windows.net/images/default/3427",
    price: 1.32
},
{
    id: 3428,
    name: "Kanpai Panda #3428",
    image: "https://prodftpserver.blob.core.windows.net/images/default/3428",
    price: 0.85
},
{
    id: 3367,
    name: "Kanpai Panda #3367",
    image: "https://prodftpserver.blob.core.windows.net/images/default/3367",
    price: 2.38
},
{
    id: 6026,
    name: "Kanpai Panda #6026",
    image: "https://prodftpserver.blob.core.windows.net/images/default/6026",
    price: 1.78
},
{
    id: 5376,
    name: "Kanpai Panda #5376",
    image: "https://prodftpserver.blob.core.windows.net/images/default/5376",
    price: 2.28
},
{
    id: 5377,
    name: "Kanpai Panda #5377",
    image: "https://prodftpserver.blob.core.windows.net/images/default/5377",
    price: 1.18
},
{
    id: 4334,
    name: "Kanpai Panda #4334",
    image: "https://prodftpserver.blob.core.windows.net/images/default/4334",
    price: 1.58
},
{
    id: 3170,
    name: "Kanpai Panda #3170",
    image: "https://prodftpserver.blob.core.windows.net/images/default/3170",
    price: 2.08
},
{
    id: 3500,
    name: "Kanpai Panda #3500",
    image: "https://prodftpserver.blob.core.windows.net/images/default/3500",
    price: 0.98
},
{
    id: 2620,
    name: "Kanpai Panda #2620",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2620",
    price: 2.44
},
{
    id: 2159,
    name: "Kanpai Panda #2159",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2159",
    price: 1.68
},
{
    id: 3920,
    name: "Kanpai Panda #3920",
    image: "https://prodftpserver.blob.core.windows.net/images/default/3920",
    price: 1.88
},
{
    id: 3919,
    name: "Kanpai Panda #3919",
    image: "https://prodftpserver.blob.core.windows.net/images/default/3919",
    price: 2.18
},
{
    id: 4693,
    name: "Kanpai Panda #4693",
    image: "https://prodftpserver.blob.core.windows.net/images/default/4693",
    price: 1.08
},
{
    id: 4692,
    name: "Kanpai Panda #4692",
    image: "https://prodftpserver.blob.core.windows.net/images/default/4692",
    price: 1.48
},
{
    id: 3635,
    name: "Kanpai Panda #3635",
    image: "https://prodftpserver.blob.core.windows.net/images/default/3635",
    price: 1.98
},
{
    id: 3636,
    name: "Kanpai Panda #3636",
    image: "https://prodftpserver.blob.core.windows.net/images/default/3636",
    price: 1.28
},
{
    id: 2731,
    name: "Kanpai Panda #2731",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2731",
    price: 0.83
},
{
    id: 2691,
    name: "Kanpai Panda #2691",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2691",
    price: 2.34
},
{
    id: 2455,
    name: "Kanpai Panda #2455",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2455",
    price: 1.74
},
{
    id: 2341,
    name: "Kanpai Panda #2341",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2341",
    price: 2.24
},
{
    id: 6859,
    name: "Kanpai Panda #6859",
    image: "https://prodftpserver.blob.core.windows.net/images/default/6859",
    price: 1.14
},
{
    id: 2062,
    name: "Kanpai Panda #2062",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2062",
    price: 1.54
},
{
    id: 2063,
    name: "Kanpai Panda #2063",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2063",
    price: 2.04
},
{
    id: 2064,
    name: "Kanpai Panda #2064",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2064",
    price: 0.94
},
{
    id: 2207,
    name: "Kanpai Panda #2207",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2207",
    price: 2.40
},
{
    id: 2741,
    name: "Kanpai Panda #2741",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2741",
    price: 1.64
},
{
    id: 3527,
    name: "Kanpai Panda #3527",
    image: "https://prodftpserver.blob.core.windows.net/images/default/3527",
    price: 1.84
},
{
    id: 6868,
    name: "Kanpai Panda #6868",
    image: "https://prodftpserver.blob.core.windows.net/images/default/6868",
    price: 2.14
},
{
    id: 2409,
    name: "Kanpai Panda #2409",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2409",
    price: 1.04
},
{
    id: 2392,
    name: "Kanpai Panda #2392",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2392",
    price: 1.44
},
{
    id: 4641,
    name: "Kanpai Panda #4641",
    image: "https://prodftpserver.blob.core.windows.net/images/default/4641",
    price: 1.94
},
{
    id: 5905,
    name: "Kanpai Panda #5905",
    image: "https://prodftpserver.blob.core.windows.net/images/default/5905",
    price: 1.24
},
{
    id: 8114,
    name: "Kanpai Panda #8114",
    image: "https://prodftpserver.blob.core.windows.net/images/default/8114",
    price: 0.86
},
{
    id: 2519,
    name: "Kanpai Panda #2519",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2519",
    price: 2.30
},
{
    id: 5155,
    name: "Kanpai Panda #5155",
    image: "https://prodftpserver.blob.core.windows.net/images/default/5155",
    price: 1.70
},
{
    id: 3491,
    name: "Kanpai Panda #3491",
    image: "https://prodftpserver.blob.core.windows.net/images/default/3491",
    price: 2.20
},
{
    id: 7884,
    name: "Kanpai Panda #7884",
    image: "https://prodftpserver.blob.core.windows.net/images/default/7884",
    price: 1.10
},
{
    id: 3372,
    name: "Kanpai Panda #3372",
    image: "https://prodftpserver.blob.core.windows.net/images/default/3372",
    price: 1.50
},
{
    id: 4525,
    name: "Kanpai Panda #4525",
    image: "https://prodftpserver.blob.core.windows.net/images/default/4525",
    price: 2.00
},
{
    id: 2474,
    name: "Kanpai Panda #2474",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2474",
    price: 0.90
},
{
    id: 4482,
    name: "Kanpai Panda #4482",
    image: "https://prodftpserver.blob.core.windows.net/images/default/4482",
    price: 2.36
},
{
    id: 5910,
    name: "Kanpai Panda #5910",
    image: "https://prodftpserver.blob.core.windows.net/images/default/5910",
    price: 1.60
},
{
    id: 2479,
    name: "Kanpai Panda #2479",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2479",
    price: 1.80
},
{
    id: 6079,
    name: "Kanpai Panda #6079",
    image: "https://prodftpserver.blob.core.windows.net/images/default/6079",
    price: 2.10
},
{
    id: 2857,
    name: "Kanpai Panda #2857",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2857",
    price: 1.00
},
{
    id: 4529,
    name: "Kanpai Panda #4529",
    image: "https://prodftpserver.blob.core.windows.net/images/default/4529",
    price: 1.40
},
{
    id: 4532,
    name: "Kanpai Panda #4532",
    image: "https://prodftpserver.blob.core.windows.net/images/default/4532",
    price: 1.90
},
{
    id: 3560,
    name: "Kanpai Panda #3560",
    image: "https://prodftpserver.blob.core.windows.net/images/default/3560",
    price: 1.20
},
{
    id: 3832,
    name: "Kanpai Panda #3832",
    image: "https://prodftpserver.blob.core.windows.net/images/default/3832",
    price: 0.84
},
{
    id: 4449,
    name: "Kanpai Panda #4449",
    image: "https://prodftpserver.blob.core.windows.net/images/default/4449",
    price: 2.26
},
{
    id: 3810,
    name: "Kanpai Panda #3810",
    image: "https://prodftpserver.blob.core.windows.net/images/default/3810",
    price: 1.66
},
{
    id: 6564,
    name: "Kanpai Panda #6564",
    image: "https://prodftpserver.blob.core.windows.net/images/default/6564",
    price: 2.16
},
{
    id: 2310,
    name: "Kanpai Panda #2310",
    image: "https://prodftpserver.blob.core.windows.net/images/default/2310",
    price: 1.06
},
{
    id: 7755,
    name: "Kanpai Panda #7755",
    image: "https://prodftpserver.blob.core.windows.net/images/default/7755",
    price: 1.46
},
{
    id: 4455,
    name: "Kanpai Panda #4455",
    image: "https://prodftpserver.blob.core.windows.net/images/default/4455",
    price: 1.96
},
{
    id: 3867,
    name: "Kanpai Panda #3867",
    image: "https://prodftpserver.blob.core.windows.net/images/default/3867",
    price: 1.26
},
{
    id: 6616,
    name: "Kanpai Panda #6616",
    image: "https://prodftpserver.blob.core.windows.net/images/default/6616",
    price: 0.87
},
{
    id: 6617,
    name: "Kanpai Panda #6617",
    image: "https://prodftpserver.blob.core.windows.net/images/default/6617",
    price: 2.32
},
{
    id: 6615,
    name: "Kanpai Panda #6615",
    image: "https://prodftpserver.blob.core.windows.net/images/default/6615",
    price: 1.72
},
{
    id: 5712,
    name: "Kanpai Panda #5712",
    image: "https://prodftpserver.blob.core.windows.net/images/default/5712",
    price: 2.22
},
{
    id: 5711,
    name: "Kanpai Panda #5711",
    image: "https://prodftpserver.blob.core.windows.net/images/default/5711",
    price: 1.12
},
{
    id: 5710,
    name: "Kanpai Panda #5710",
    image: "https://prodftpserver.blob.core.windows.net/images/default/5710",
    price: 1.52
},
{
    id: 6606,
    name: "Kanpai Panda #6606",
    image: "https://prodftpserver.blob.core.windows.net/images/default/6606",
    price: 2.02
},
{
    id: 5750,
    name: "Kanpai Panda #5750",
    image: "https://prodftpserver.blob.core.windows.net/images/default/5750",
    price: 1.32
}
];
